export { AccountOpeningV2TrustedContactIntroStep } from './AccountOpeningV2TrustedContactIntroStep';
